var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"go-to-project",attrs:{"target":"_blank","href":_vm.dataStore.project.currentUrl}},[_vm._v(_vm._s(_vm.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }